const testimonials = [
  {
    id: 1,
    name: 'Arun Choudhary',
    title: 'Project Work',
    org: 'WEB Arun',
    desc:
      'I keep develop the project the best, I can with the help of my experience.',
  },
  {
    id: 2,
    name: 'Arun Choudhary',
    title: 'Project Managment',
    org: 'Web Arun',
    desc: 'After creating my pojects. I also manage them well.',
  },
  {
    id: 3,
    name: 'Arun Choudhary',
    title: 'On Learning',
    org: 'Web Arun',
    desc:
      'What I donot knew and what I forget. I keep on remenbering from my notes.',
  },
];
export default testimonials;
